import React from 'react';
import Icon from '../../../components/AppIcon';

const StrategicCompliancePanel = ({ metrics, onDrillDown }) => {
  const getComplianceColor = (score) => {
    if (score >= 95) return 'text-success';
    if (score >= 85) return 'text-warning';
    return 'text-error';
  };

  const getComplianceBg = (score) => {
    if (score >= 95) return 'bg-success/10';
    if (score >= 85) return 'bg-warning/10';
    return 'bg-error/10';
  };

  const complianceAreas = [
    { 
      id: 'employment-act', 
      name: 'PNG Employment Act', 
      icon: 'FileText', 
      score: metrics?.[1]?.value || 0,
      path: '/compliance-library'
    },
    { 
      id: 'nasfund', 
      name: 'NASFUND Compliance', 
      icon: 'Shield', 
      score: metrics?.[2]?.value || 0,
      path: '/payroll-compliance'
    },
    { 
      id: 'swt', 
      name: 'SWT Accuracy', 
      icon: 'DollarSign', 
      score: metrics?.[3]?.value || 0,
      path: '/payroll-compliance'
    }
  ];

  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h3 className="font-heading font-semibold text-lg text-foreground mb-1">
            Strategic Compliance Overview
          </h3>
          <p className="caption text-sm text-muted-foreground">
            PNG regulatory adherence and compliance status
          </p>
        </div>
        <button
          onClick={() => onDrillDown?.('/compliance-overview')}
          className="flex items-center gap-2 text-sm text-primary hover:underline"
        >
          <span>View All</span>
          <Icon name="ArrowRight" size={16} color="var(--color-primary)" />
        </button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {complianceAreas?.map((area) => (
          <div
            key={area?.id}
            onClick={() => onDrillDown?.(area?.path)}
            className="bg-muted border border-border rounded-lg p-5 transition-smooth hover:shadow-md cursor-pointer hover-lift"
          >
            <div className="flex items-center justify-between mb-4">
              <div className={`${getComplianceBg(area?.score)} p-3 rounded-md`}>
                <Icon name={area?.icon} size={20} color={`var(--color-${area?.score >= 95 ? 'success' : area?.score >= 85 ? 'warning' : 'error'})`} />
              </div>
              <div className={`text-3xl font-bold ${getComplianceColor(area?.score)}`}>
                {area?.score}%
              </div>
            </div>
            <h4 className="font-medium text-foreground mb-1">{area?.name}</h4>
            <div className="flex items-center gap-2">
              <div className="flex-1 bg-background rounded-full h-2 overflow-hidden">
                <div 
                  className={`h-full ${area?.score >= 95 ? 'bg-success' : area?.score >= 85 ? 'bg-warning' : 'bg-error'}`}
                  style={{ width: `${area?.score}%` }}
                />
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default StrategicCompliancePanel;